import { API, METHODS } from '@constants/api';
import { HttpMethod, PageConfig } from '@/types';
import { VITE_NODE_ENV } from '@utils/getEnv';

interface ApiServiceParams {
  endpoint: string;
  method: HttpMethod;
  body?: PageConfig['save_model'];
}

class ApiService {
  // Use relative URL so browser sees same-origin and Vite proxy handles the rest
  static baseUrl: string = API.baseUrl || '/api';
  static authToken: string = VITE_NODE_ENV['VITE_AUTH_TOKEN'];

  static async request<D>({
    endpoint,
    method = METHODS.GET,
    body,
  }: ApiServiceParams): Promise<D> {
    try {
      console.log('auth token', this.authToken);

      // Combine baseUrl with endpoint (endpoint should start with /dashboard..., /auth..., etc.)
      const url = `${this.baseUrl}${endpoint}`;

      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `Token ${this.authToken}`,
          'Content-Type': 'application/json',
        },
        body: body ? JSON.stringify(body) : undefined,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Fetch error:', error);
      throw error;
    }
  }
}

export default ApiService;
